export const classNames = (...xs) => xs.filter(Boolean).join(' ')
